import { BlockType } from '@/libs/types'
import React from 'react'

interface ContentHeaderProps extends BlockType {
    variant: "h1" | "h2" | "h3" | "h4"
}

const ContentHeader: React.FC<ContentHeaderProps> = ({
    subtitle,
    title,
    description,
    variant
}) => {
    return (
        <div className="content-one-header">
            {subtitle && (<p className="subtitle fw-bold">{subtitle}</p>)}
            {title && React.createElement(variant, {}, title)}
            {description && <p>{description}</p>}
        </div>
    )
}

export default ContentHeader